import { ActionReducerMap } from '@ngrx/store';
import { appMetaReducer, AppMetaState } from './app-meta/app-meta.reducer';
import { configReducer, ConfigState } from './config/config.reducer';


export interface AppState {
  appMetaState: AppMetaState;
  configState: ConfigState;
}

export const appReducer: ActionReducerMap<AppState, any> = {
  appMetaState: appMetaReducer,
  configState: configReducer,
}
